module.exports = __webpack_public_path__ + "img/pic_number_90.2724b3d0.png";